module.exports = __webpack_public_path__ + "img/24.6ed7779b.gif";